import { isNil, uniq, map, prop } from 'ramda';
import * as querystring from 'querystring';
import { DataStates } from "../../../store/global/data-state";
import { BookingService } from '../services/booking-service';
import { sendMailHref } from '../../../utility';

export const defaultInvoiceLines = () => {
  return {
    ...{
      dataState: DataStates.LOADING,
      data: []
    }
  };
}

export const categorizeInvoiceLines = (invoiceLines = [], calendarDateId) => {

  if (isNil(invoiceLines) || invoiceLines.length == 0) {
    return [];
  }

  const artistInvoiceLines = invoiceLines.filter(e => e.artist_name);
  const cidInvoiceLines = invoiceLines.filter(e => !e.artist_name);


  // const cidInvoiceLines = invoiceLines.filter(e => e.external_table2 == 'event');
  // const artistInvoiceLines = invoiceLines.filter(e => e.external_table2 == 'calendar_date_artist');


  let idList = uniq(map(prop('external_id2'), artistInvoiceLines));
  // Makes sure that calendarDateId is always at the first

  if (calendarDateId) {
    idList = [calendarDateId, ...idList.filter(e => e != calendarDateId)];
  } else {
    throw Error('Pass a valid Calendar Date Id');
  }

  // console.log(idList, invoiceLines, artistInvoiceLines);
  // idList

  return idList.map(eid => {
    return {
      external_id2: eid,
      title: `Deal #${eid} ${invoiceLines.find(e => e.external_id2 == eid)?.['artist_name'] || ''}`,
      invoice_lines: ((cidInvoiceLines.length > 0 && eid == calendarDateId) ? cidInvoiceLines : artistInvoiceLines.filter(e => e.external_id2 == eid)).map(e => ({
        ...e,
        isEditable: !e['color']
      })),
      expanded: true
    };
  });
}


const createInvoiceLine = ({
  last_modified = undefined,
  external_id = undefined,
  item_name = undefined,
  external_table2 = undefined,
  due_date = undefined,
  invoice_item_id = undefined,
  qty = undefined,
  price = undefined,
  invoiceline_id = undefined,
  created = undefined,
  booking_type = undefined,
  cost_center1 = undefined,
  external_id2 = undefined,
  artist_name = undefined,
  contra_account = undefined,
  text = undefined,
  vat = undefined,
  invoice_id = undefined,
  cost_center2 = undefined,
  tax_type_id = undefined,
  vat_type = undefined,
  external_table = undefined,
  pre_currency_id = undefined,
  isEditable = undefined
}) => {
  return {
    last_modified,
    external_id,
    item_name,
    external_table2,
    due_date,
    invoice_item_id,
    qty,
    price,
    invoiceline_id,
    created,
    booking_type,
    cost_center1,
    external_id2,
    artist_name,
    contra_account,
    text,
    vat,
    invoice_id,
    cost_center2,
    tax_type_id,
    vat_type,
    external_table,
    pre_currency_id,
    isEditable
  }
};


// Send a Invoice Mail
export const mailInvoice = async (invoiceLine, comp = {}) => {
  // const paypalMsg = await BookingService.findPaypalPaymentMsg({
  //   invoiceId: invoiceLine.invoice_id
  // });

  const emailDetails = await BookingService.findInvoiceEmailDetails({
    invoiceId: invoiceLine.invoice_id,
  });

  const email = emailDetails.data.email;
  const emailText = emailDetails.data.invoice_email_text;

  sendMailHref({
    subject: 'Invoice Details',
    body: emailText,
    mails: [email]
  });
}
